// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import {
  InstrumentConfiguration,
  InstrumentConfigurationFactory,
} from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveAndCreateDtccTokenInstrumentConfiguration: () => UseMutationResult<
  void,
  string,
  {
    registrarServiceCid: ContractId<RegistrarService>;
    instrumentConfigurationFactoryCid: ContractId<InstrumentConfigurationFactory>;
    instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
    tokenName: string;
    tokenSymbol: string;
    cusip: string;
    shortDescription: string;
    issueType: string;
    issueSubtype: string;
    properties: { [key: string]: string };
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveAndCreateDtccTokenInstrumentConfiguration', ledgerApi],
    mutationFn: async ({
      registrarServiceCid,
      instrumentConfigurationFactoryCid,
      instrumentConfigurationCid,
      tokenName,
      tokenSymbol,
      cusip,
      shortDescription,
      issueType,
      issueSubtype,
      properties,
    }) => {
      return ledgerApi.archiveAndCreateRegistryDtccTokenInstrumentConfiguration(
        registrarServiceCid,
        instrumentConfigurationFactoryCid,
        instrumentConfigurationCid,
        tokenName,
        tokenSymbol,
        cusip,
        shortDescription,
        issueType,
        issueSubtype,
        properties,
      );
    },
    retry: false,
  });
};

export default useArchiveAndCreateDtccTokenInstrumentConfiguration;
